export const experienceData = [
  {
    id: 1,
    role: "Machine Learning Intern",
    company: "Nitroware Technologies Pvt Ltd",
    location: "Coimbatore, India",
    startDate: "January 2025",
    endDate: "February 2025",
    type: "Internship",
    description: "Developed Sugarcane Yield Prediction System integrating ML models and Django web app with effective feature engineering and intuitive UI.",
    responsibilities: [
      "Developed and deployed ML models for sugarcane yield prediction",
      "Built Django-based web interface with interactive visualizations",
      "Implemented feature engineering techniques to improve model accuracy",
      "Collaborated with agricultural experts to validate predictions"
    ],
    technologies: ["Python", "Django", "Scikit-learn", "Pandas", "JavaScript", "PostgreSQL"]
  },
  {
    id: 2,
    role: "Junior Developer",
    company: "Hyperready Technology",
    location: "Coimbatore, India",
    startDate: "October 2025",
    endDate: "February 2026",
    type: "Internship",
    description: "Working on real-time projects and gaining hands-on experience in software development.",
    responsibilities: [
      "Assisting in the automation of task using the TypeScript (mastra)",
      "Collaborating with the development teams",
      "Working on LLM intergration for various features"
    ],
    technologies: ["LLM", "TypeScript", "Mastra", "JavaScript"]
  }
];
